import * as React from 'react';
import ConfigurationValuesService, { IConfigurationValuesService } from '../../services/ConfigurationValuesService';
import '../../styles/css/index.css';
class Footer extends React.Component {
    private readonly configurationValuesService: IConfigurationValuesService;

    constructor(props: any) {
        super(props);
        this.configurationValuesService = ConfigurationValuesService.getInstance();
    }

    public render() {
        if (this.configurationValuesService.showCustomTranslatorTemplate) {
            return null;
        }

        const {
            supportUrl,
            privacyPolicyUrl
        } = this.configurationValuesService;

        // TODO: Move hardcoded SJ urls to configuration
        return (
            <div className='footer'>
                <div className={'footer-content'}>
                    <div className='links'>
                        <div id='support-link'>
                            <a href={ supportUrl || 'https://www.swipejobs.com/support'}>Support</a>
                        </div>
                        <div id='support-link'>
                            <a href={ privacyPolicyUrl || 'https://www.swipejobs.com/privacy'}>Privacy</a>
                        </div>
                        <div id='support-link'>
                            <a href={ supportUrl || 'https://www.swipejobs.com/support'}>FAQs</a>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.tsx